import React from "react";
import Layout from "@app/Layout";
import Canonical from "@shared/head/Canonical";
import Breadcrumbs from "@shared/head/Breadcrumbs";

import Hero from "@features/support/Hero";
import Features from "@features/support/Features";
import Seats from "@features/support/Seats";
import Steps from "@features/support/Steps";
import FinalCTA from "@features/support/FinalCTA";

export const Head = () => (
  <>
    <title>Dashly for support teams</title>
    <meta
      name="description"
      content="Discover Dashly to let your team provide the best customer experience with live chat, knowledge base, chatbots and powerful automation."
    />
    <Canonical url="https://www.dashly.io/support/" />
    <Breadcrumbs
      list={[
        { name: "Dashly", url: "https://www.dashly.io/" },
        { name: "Dashly for support teams", url: "https://www.dashly.io/support/" },
      ]}
    />
  </>
);

export default function SupportPage({ location }: { location: Location }) {
  return (
    <Layout location={location} className="new-design ds-2026">
      <Hero />
      <Features />
      <Seats />
      <Steps />
      <FinalCTA />
    </Layout>
  );
}
